import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const TOP_SELLERS = ['AD', 'KO', 'FC', 'IS'];

export const HeroVisual = () => {
  const { t } = useApp();
  return (
    <div className="relative">
      <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] bg-[#FAF7F2]">
        <img src="https://images.pexels.com/photos/36096126/pexels-photo-36096126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="West African marketplace" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/60 via-transparent to-transparent" />
      </div>
      <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 border border-[#EFEAE0] hidden sm:block w-56">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#0F8B5C]/10 flex items-center justify-center"><TrendingUp className="w-5 h-5 text-[#0F8B5C]" /></div>
          <div>
            <div className="text-2xl font-black text-[#1A1A1A] leading-none">+340%</div>
            <div className="text-xs text-[#7A7468] mt-1">{t('hero.boostViews')}</div>
          </div>
        </div>
      </div>
      <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4 border border-[#EFEAE0] hidden sm:block w-60">
        <div className="text-xs font-semibold text-[#7A7468] uppercase tracking-wider mb-2">{t('hero.topSellers')}</div>
        <div className="flex -space-x-2 mb-2">
          {TOP_SELLERS.map((a) => (
            <div key={a} className="w-8 h-8 rounded-full bg-[#0F8B5C] ring-2 ring-white flex items-center justify-center text-white text-[10px] font-bold">{a}</div>
          ))}
          <div className="w-8 h-8 rounded-full bg-[#F2B441] ring-2 ring-white flex items-center justify-center text-[#1A1A1A] text-[10px] font-bold">+2K</div>
        </div>
        <div className="text-xs text-[#3F3A30]">{t('hero.activeSellers')}</div>
      </div>
    </div>
  );
};
